import { request as queryRequest } from './reducers/query';
import { request as createRequest } from './reducers/create';
import { request as updateParticipant } from './reducers/update-participant';

// eslint-disable-next-line import/no-default-export
export default {
    PARTICIPANTS_QUERY_REQUEST: queryRequest,
    PARTICIPANTS_CREATE_REQUEST: createRequest,
    PARTICIPANT_UPDATED_REQUEST: updateParticipant,
};
